// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { FluentProvider } from "@fluentui/react-components";
import { msalConfig } from "./authConfig";
import { lekOilLightTheme } from "./theme/theme";
import App from "./App";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <FluentProvider theme={lekOilLightTheme}>
          <App />
        </FluentProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
